import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentHeader, Divider } from '_template';
import Breadcrumbs from 'components/Breadcrumbs';
import Actions from './components/Actions';
import ConsultantTable from './components/ConsultantTable';
import { RIGHTS } from 'constants/rights';
import LimitedAccess from 'components/LimitedAccess';
import Helmet from 'components/Helmet';

const ConsultantList = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet title={t<string>('CONSULTANT.MODEL_TITLE')} />
      <ContentHeader
        title={t('CONSULTANT.MODEL_TITLE')}
        actions={<Actions />}
        breadcrumbs={<Breadcrumbs section={t('CONSULTANT.MODEL_TITLE')} />}
      />
      <Divider sx={{ my: 4 }} />
      <LimitedAccess right={RIGHTS.CONSULTANT.LIST}>
        <ConsultantTable />
      </LimitedAccess>
    </>
  );
};

export default ConsultantList;
